export default class TransactionList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}
	}

	static async fetch () {

		let data = await Anvil.REST.get('/transaction')

		return new TransactionList(data)
	}

	getById (id) {
		return this.index[id]
	}
}
